module.exports = __webpack_public_path__ + "img/bike_orange.c0df91ce.svg";